import React, {PureComponent, Fragment} from "react"
import {Route, match as Match} from "react-router-dom"
import moment from "moment"

import {NestedRoute, IndexRedirect} from "@irati/utils/history/routing"
import authentication from "@irati/auth"
import {BusinessOverviewDuration} from "@irati/types"
import adminReportingService from "@irati/adminReporting/services/adminReporting"
import {hasPayrollPay} from "@irati/products/utils/hasPayrollPay"
import devToggles from "@irati/dev-toggles"

import Spacing from "@irati/ui/src/Spacing"
import Loading from "@irati/ui/src/Loading"
import Overall from "../containers/Reporting/Overall"
import Celebrations from "../containers/Reporting/Celebrations"
import Perks from "../containers/Reporting/Perks"
import Benefits from "../containers/Reporting/Benefits"
import Wellbeing from "../containers/Reporting/Wellbeing"
import MaximiseUsage from "../components/Dashboard/Reporting/Widgets/MaximiseUsage"

interface Props {
  match: Match
  apps: {}
}

interface State {
  showMaximiseUsageWidget: boolean
  load: Promise<any> | null
}

class Reporting extends PureComponent<Props, State> {
  state = {
    showMaximiseUsageWidget: false,
    load: null
  }

  componentDidMount() {
    const businessId = authentication.business().uuid
    const load = Promise.all([
      adminReportingService.getBusinessSettings(businessId),
      adminReportingService.getBusinessOverview({businessId, duration: BusinessOverviewDuration.BusinessOverviewLast_12Months})
    ]).then(([settings, overview]) => {
      const isOverrideActive = settings?.showUntil?.seconds && moment().isBefore(moment.unix(settings.showUntil.seconds))
      const showMaximiseUsageWidget = overview.showMaximiseUsage && !isOverrideActive
      this.setState({showMaximiseUsageWidget})
    })
    this.setState({load})
  }

  render() {
    const {match} = this.props
    const {showMaximiseUsageWidget, load} = this.state

    const isPerksEnabled = authentication.apps("perks")
    const {benefits, wellnessHub, medical} = authentication.apps()
    const isWellbeingEnabled = devToggles.showPayrollPayBenefits() && wellnessHub && (benefits?.eap || medical?.onlineGP)
    const isPayrollPayEnabled = hasPayrollPay() && devToggles.showPayrollPayBenefits()

    if (showMaximiseUsageWidget) {
      return (
        <Spacing padding={2}>
          <MaximiseUsage />
        </Spacing>
      )
    }

    return (
      <Loading load={load}>
        <Route
          path={match.url}
          render={() => (
            <Fragment>
              <NestedRoute match={match.url} path="/overall" component={Overall} />
              <NestedRoute match={match.url} path="/celebrations" component={Celebrations} />
              {isPerksEnabled && <NestedRoute match={match.url} path="/perks" component={Perks} />}
              {isPayrollPayEnabled && <NestedRoute match={match.url} path="/benefits" component={Benefits} />}
              {isWellbeingEnabled && <NestedRoute match={match.url} path="/wellbeing" component={Wellbeing} />}
              <IndexRedirect match={match.url} to="/overall" title="Admin Analytics Overall" />
            </Fragment>
          )}
        />
      </Loading>
    )
  }
}

export default Reporting
